<template>
  <div id="app">
     <div>
		 <router-view/>
	 </div>
  </div>
</template>

<script>


export default {
  name: 'App',
  
}
</script>

<style>
#app {
	min-width: 1200px;
/*  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
